import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';
import { Header, Segment } from 'semantic-ui-react';
import LoadingComponent from '../../app/layout/LoadingComponent';
import { useStore } from '../../app/stores/store';
import '../../app/common/MediaQuery/responsive-tables.css';
import UnauthorizedMessage from '../UnauthorizedMessage';
import DynamicTableFrontEnd from '../DynamicTable/DynamicTableFrontEnd';

function DepartmentMasterTable() {
  const { departmentStore, commonStore } = useStore();
  const {
    loadDepartments,
    departmentRegistry,
    departmentitemsByDate,
    loading,
  } = departmentStore;
  const { dashboardStore } = useStore();
  const [showText, setShow] = useState(false);

  useEffect(() => {
    if (departmentRegistry.size <= 1) loadDepartments();
  }, [departmentRegistry.size, loadDepartments]);

  useEffect(() => {
    setShow(true);
  }, []);

  const removeCol =
    'isReceiving,isDelivery,isReceivingOrder,files,assignedUsers,comments,itemHistory,orders,itemDeliveryRequest,inwards,receivings,host,isDeleted,isActive,cast,thumbnail_large,thumbnail_small,groove_type,speed_and_speed_adjustment,number_of_channels_and_sound_channel_map,file_format_name_and_version,analog_media,format_in_terms_of_broadcast_standards,bits_per_sample_and_sampling_description,songs,physcial_format,host,hostUsername,originIndia,itemCreatedAt,inactive,isgoing,ishost';
  const DepartmentTable = JSON.parse(JSON.stringify(departmentitemsByDate));
  DepartmentTable.map((i: any) => removeCol.split(',').map((j) => delete i[j]));

  // if (!loadDepartments || loading) return <LoadingComponent />;
  return (
    <>
      {dashboardStore.dashboard.loadingdata === 'loading' && (
        <LoadingComponent />
      )}
      {dashboardStore.dashboard.loadingdata !== 'loading' &&
        !commonStore.filterModeOne?.includes('DMVB01') && (
          <UnauthorizedMessage />
        )}
      {commonStore.filterModeOne?.includes('DMVB01') && (
        <div className="large-table-screen">
          <div className="small-table-screen">
            <Segment>
              <Header
                clearing
                icon="list"
                size="huge"
                dividing
                as="h1"
                content="View Departments"
                sub
                color="grey"
              />
              {showText && (
                <DynamicTableFrontEnd
                  data={DepartmentTable}
                  name={'DepartmentTable'}
                  actiontype={'editdel'}
                  loading={!loadDepartments || loading}
                />
              )}
            </Segment>
          </div>
        </div>
      )}
    </>
  );
}

export default observer(DepartmentMasterTable);
